<template>
  <v-container fluid :fill-height="loading" class="leave-contact-info py-0">

    <v-progress-linear style="position: fixed; left: 0; right: 0; margin: 0; z-index: 99;"
                       :style="{top: $vuetify.breakpoint.smAndDown ? '54px' : '62px'}" color="primary lighten-2"
                       height="2" v-show="subtleLoading" :indeterminate="true"></v-progress-linear>

    <hb-loading-indicator v-if="loading" align-middle/>

    <v-fade-transition>
      <v-row v-if="!loading">
        <v-col cols="12" md="6" offset-md="3" xl="4" offset-xl="4">
          <v-card>
            <v-fade-transition hide-on-leave>
              <v-card-text v-if="!showThanks" class="black--text">
                <div class="title mt-7 mb-7">{{ $t('public_job_ads.leave_contact_info_help') }}</div>
                <v-form ref="form">
                  <v-row>
                    <v-col cols="12" class="py-1">
                      <v-text-field v-model="firstName"
                                    v-on:keyup.enter="submitForm"
                                    :rules="[$rules.required]"
                                    :label="$t('public_job_ads.first_name')"
                                    outlined
                                    class="rounded"
                                    validate-on-blur />
                    </v-col>
                    <v-col cols="12" class="py-1">
                      <v-text-field v-model="lastName"
                                    v-on:keyup.enter="submitForm"
                                    :rules="[$rules.required]"
                                    :label="$t('public_job_ads.last_name')"
                                    outlined
                                    class="rounded"
                                    validate-on-blur />
                    </v-col>
                    <v-col cols="12" class="py-1">
                      <v-text-field v-model="phone"
                                    v-on:keyup.enter="submitForm"
                                    :rules="[$rules.required]"
                                    :label="$t('public_job_ads.phone')"
                                    outlined
                                    class="rounded"
                                    validate-on-blur />
                    </v-col>
                    <v-col cols="12" class="py-1">
                      <v-text-field v-model="email"
                                    v-on:keyup.enter="submitForm"
                                    :rules="[$rules.required, $rules.email]"
                                    :label="$t('public_job_ads.email')"
                                    @change="email = email.trim()"
                                    outlined
                                    class="rounded"
                                    validate-on-blur />
                    </v-col>
                    <v-col cols="12" class="py-1">
                      <v-text-field v-model="address"
                                    v-on:keyup.enter="submitForm"
                                    :rules="[$rules.required]"
                                    :label="$t('public_job_ads.address')"
                                    outlined
                                    class="rounded"
                                    validate-on-blur />
                    </v-col>
                    <v-col cols="12" class="py-1">
                      <v-text-field v-model="zipcode"
                                    v-on:keyup.enter="submitForm"
                                    :rules="[$rules.required]"
                                    :label="$t('public_job_ads.zipcode')"
                                    outlined
                                    class="rounded"
                                    validate-on-blur />
                    </v-col>
                    <v-col cols="12" class="py-1">
                      <v-text-field v-model="city"
                                    v-on:keyup.enter="submitForm"
                                    :rules="[$rules.required]"
                                    :label="$t('public_job_ads.city')"
                                    outlined
                                    class="rounded"
                                    validate-on-blur />
                    </v-col>
                    <v-col cols="12" class="py-1">
                      <v-text-field :value="cvFileName"
                                    prepend-inner-icon="mdi mdi-paperclip"
                                    :label="$t('cv')"
                                    readonly
                                    @click="changeCV"
                                    @click:clear="clearCV"
                                    outlined
                                    class="rounded"
                                    clearable />
                      <input type="file" style="display:none" :multiple="false" ref="cvFileInput" @change="onCVFileChanged">
                    </v-col>
                  </v-row>
                </v-form>
                <v-btn color="primary" :disabled="loadingCV" :loading="sending" :block="$vuetify.breakpoint.smAndDown" class="mt-7 accent-2--text" @click="submitForm">{{ $t('send') }}</v-btn>
              </v-card-text>
            </v-fade-transition>
            <v-fade-transition hide-on-leave>
              <v-card-text v-if="showThanks" class="black--text">
                <v-container fill-height>
                  <v-row>
                    <v-col cols="12" class="py-16 mt-16">
                      <div style="position: relative;">
                        <v-img :src="$assetImageUrl + 'img/face-1.svg'" width="125" class="face"/>
                        <div class="headline mb-5">{{ $t('public_job_ads.thanks') }}</div>
                        <div class="title mb-5">{{ $t('public_job_ads.follow_your_emails') }}</div>
                        <!-- <v-btn color="primary" :block="$vuetify.breakpoint.smAndDown" class="accent-2--text" href="https://hrsata.fi/">{{ $t('public_job_ads.move_to_hrsata_frontpage') }}</v-btn> -->
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-fade-transition>
          </v-card>
        </v-col>
      </v-row>
    </v-fade-transition>
  </v-container>
</template>

<script>
import sharedApi from '@/jobs/api/shared';

export default {
  name: "LeaveContactInfo",
  data() {
    return {
      loading: true,
      subtleLoading: false,
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      address: '',
      zipcode: '',
      city: '',
      sending: false,
      showThanks: false,
      cv: null,
      loadingCV: false,
    }
  },
  computed: {
    cvFileName() {
      return this.loadingCV ? this.$t('loading_cv') : this.cv?.name;
    },
  },
  methods: {
    changeCV() {
      if (!this.loadingCV) {
        this.$refs.cvFileInput.click();
      }
    },
    clearCV() {
      this.cv = null;
      this.$refs.cvFileInput.value = null;
    },
    async onCVFileChanged(event) {
      this.loadingCV = true;
      const reader = new FileReader();
      const file = event.target.files[0];
      if (file) {
        reader.onloadend = () => {
          const base64 = btoa(reader.result);
          this.cv = {
            name: file.name,
            dataType: file.type,
            dataSize: file.size,
            base64Data: base64,
          };
          this.loadingCV = false;
        }
        reader.readAsBinaryString(file);
      } else {
        this.loadingCV = false;
      }
    },
    async submitForm() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.sending = true;
      try {
        await sharedApi.leaveContactInfo({
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          phone: this.phone,
          address: this.address,
          zipcode: this.zipcode,
          city: this.city,
          cv: this.cv,
        });
        this.showThanks = true;
      } catch (error) {
        this.$handleApiError(error);
      }
      this.sending = false;
    },
  },
  mounted() {
    this.loading = false;
  }
}
</script>

<style lang="scss" scoped>
.face {
  position: absolute;
  top: -120px;
  right: 20px;
}

@media only screen and (min-width: 1200px) {
  .face {
    top: -120px;
    right: 60px;
  }
}
</style>
